import { ChevronDownIcon } from '../../icons';
import { cx } from '../../utils/cx';

import type { IIconProps } from '../../icons/createIcon';

export interface IToggleCaretProps extends IIconProps {
  /** When true the caret rotates 180° (points up); when false it points down. */
  isOpen: boolean;
}

/**
 * A downward chevron that smoothly rotates 180° when toggled open — the
 * twist-on-click caret for collapsible headers (cards, table rows, etc.).
 * Decorative by default (`aria-hidden`); the interactive element wrapping it
 * owns the label and `aria-expanded`. Size and color come from `className`
 * (defaults to `size-5`, inheriting color).
 */
const ToggleCaret = ({ isOpen, className, ...props }: IToggleCaretProps) => (
  <ChevronDownIcon
    aria-hidden
    {...props}
    className={cx(
      'pointer-events-none size-5 shrink-0 transition-transform duration-200',
      isOpen && 'rotate-180',
      className
    )}
  />
);

ToggleCaret.displayName = 'ToggleCaret';

export default ToggleCaret;
